import React, {useRef} from 'react';
import {useState} from 'react';
import {Intent} from '~/lib/intent';
import {classByIntent} from '~/lib/intent';
import style from './index.module.scss';

export interface IMultiInputProps {
    value: string[];
    onChange: (value: string[]) => void;
    intent?: Intent;
    disabled?: boolean;
    placeholder?: string;
}

type IMultiSelectState = {
    filter?: string;
};

export const MultiInput = ({value: values, onChange, disabled, intent, placeholder}: IMultiInputProps) => {
    const contentRef = useRef<HTMLDivElement>(null);
    const inputRef = useRef<HTMLInputElement>(null);

    let [state, setState] = useState<IMultiSelectState>({
        filter: ''
    });

    let multiInputClasses = [style.multiInput, classByIntent(intent)];

    if (disabled) {
        multiInputClasses.push(style.disabled);
    }

    return <div className={style.multiInputWrapper} ref={contentRef}>
        <div className={multiInputClasses.join(' ')} onClick={() => !disabled && inputRef.current?.focus()}>
            <div className={style.multiInputValues}>
                {(values || []).map((value, index) => <span key={index} className={style.multiInputValue}>
                    {value}
                    {!disabled && <i className={['fa fa-close', style.multiInputRemove].join(' ')} onClick={() => {
                        onChange((values || []).filter((_, valueIndex) => index !== valueIndex));
                    }}/>}
                </span>)}
                <input
                    className={style.multiInputInput}
                    ref={inputRef}
                    placeholder={placeholder}
                    onBlur={(event) => {
                        const target = event.target as HTMLInputElement;
                        event.preventDefault();
                        const value = target.value.trim();
                        if (value !== '') {
                            onChange((values || []).concat(value));
                            target.value = '';
                            setState({...state, filter: target.value.trim()});
                        }
                    }}
                    onKeyDown={(event) => {
                        const target = event.target as HTMLInputElement;
                        const value = target.value.trim();
                        if (event.keyCode === 13 && value !== '') {
                            event.preventDefault();
                            onChange((values || []).concat(value));
                            target.value = '';
                        }
                        setState({...state, filter: target.value.trim()});
                    }} onKeyUp={(event) => {
                        const target = event.target as HTMLInputElement;
                        setState({...state, filter: target.value});
                    }}/>
            </div>
            {(values || []).length > 0 && !disabled &&
                <i className={['fa fa-close', style.multiInputClear].join(' ')} onClick={() => onChange([])}/>
            }
        </div>
    </div>;
};
